import { Fee } from "../fee";
import { Fiat } from "../asset/fiat/fiat";
import { FiatLimit } from "../fiat_limits";
import { Field } from "../field";
import { Model } from "../model";
import { PROVIDER_AMAZON, PROVIDER_BANK_TRANSFER, PROVIDER_HAVALE, PROVIDER_SEPA } from "@helpers/constants";

export abstract class Provider extends Model {
	private short_name: string = "";
	private description: string = "";
	private fiat_provider_details: Fee[] = [new Fee()];
	private terms: string = "";
	private name: string = "";
	private unavailable: boolean = false;
	private needs_verification: boolean = true;
	private is_instant: boolean = false;
	private enabled: boolean = false;

	public is_voucher: boolean = false;
	private logo: string = "";
	private logo_dark: string = "";

	public limits: FiatLimit[] = [];

	public sort: number = Number.MAX_VALUE;

	public fields: Field[] = [new Field()];
	protected is_logo_descriptive: boolean = false;

	public isInstant(): boolean {
		return this.is_instant;
	}

	public getFeeByFiatId(id: string): Fee {
		return this.getFees().find((f: Fee) => f.getFiatId() === id);
	}

	public getShortName(): string {
		return this.short_name;
	}

	public getName(): string {
		return this.name;
	}

	public getFiatIDs(): string[] {
		return this.getFees().map((f: Fee) => f.getFiatId());
	}

	public getCountForFiat(id: string): number {
		return this.fiat_provider_details.find((f: Fee) => f.getFiatId() === id).getAllowedPayoutAccounts();
	}

	public getTerms(): string {
		return this.terms;
	}

	public isUnavailable(): boolean {
		return this.unavailable;
	}

	public needsVerification(): boolean {
		return this.needs_verification;
	}

	public hasFiat(f: Fiat): boolean {
		return this.getFees().some((fee: Fee) => fee.getFiatId() === f.getId());
	}

	public getDescription(): string {
		return this.description;
	}

	public getLimits(): FiatLimit[] {
		return this.limits;
	}

	public setLimits(fs: FiatLimit[]): void {
		this.limits = fs;
	}

	public getLimitForFiat(f: Fiat): FiatLimit {
		return this.getLimitForFiatId(f.getId());
	}

	public getLimitForFiatId(id: string): FiatLimit {
		return this.limits.find((l: FiatLimit) => l.getFiatId() === id);
	}

	public getFees(): Fee[] {
		return this.fiat_provider_details.filter((f: Fee) => f.getFiatId() !== "");
	}

	public getFields(): Field[] {
		return this.fields.filter((f: Field) => f.getName().length > 0);
	}

	public hasTerms(): boolean {
		return this.getTerms().length > 0;
	}

	public isEnabled(): boolean {
		return this.enabled;
	}

	public getLogo(darkModeEnabled: boolean = false): string {
		return darkModeEnabled ? this.logo_dark : this.logo;
	}

	public getLogoDark(): string {
		return this.logo_dark;
	}

	public isNonSepaBank(): boolean {
		return this._isShortNameBankTransfer() || this._isShortNameHavale();
	}

	public isShortNameSepa(): boolean {
		return this.getShortName() === PROVIDER_SEPA;
	}

	private _isShortNameBankTransfer(): boolean {
		return this.getShortName() === PROVIDER_BANK_TRANSFER;
	}

	private _isShortNameHavale(): boolean {
		return this.getShortName() === PROVIDER_HAVALE;
	}

	public isShortNameAmazon(): boolean {
		return this.getShortName() === PROVIDER_AMAZON;
	}

	public getFiatProviderDetails(): Fee[] {
		return this.fiat_provider_details;
	}

	public isLogoDescriptive(): boolean {
		return this.is_logo_descriptive;
	}
}
